<script>
  import _debounce from 'lodash/debounce'
  export default {
    props: {
      value: {
        type: Array,
        default: () => {
          return []
        }
      },
      title: {
        type: String,
        default: ''
      },
      titleClass: {
        type: String,
        default: ''
      },
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
      type: {
        type: String,
        default: 'prompt',
        validator(value) {
          return [
            'prompt',
            'click',
          ].includes(value)
        },
      },
      isShow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isOpenDropdownMenu: this.isShow || !!this.value.length,
        isOpenMenu: false,
      }
    },
    computed: {
      data: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      buttonBarList() {
        return [
          {
            text: '確定篩選',
            class: 'flex-grow-1',
            buttonClass: 'isStylePrimary isRadius isSmall isFull',
            isDisabled: !this.list.length,
            onClick: () => {
              this.$emit('changeFilter', false)
              this.isOpenMenu = false
            },
          },
          {
            text: '刪除篩選',
            class: 'flex-grow-1',
            buttonClass: 'isStyleDark isOutline2 isRadius isSmall isFull',
            isDisabled: !this.list.length,
            onClick: () => {
              this.data = []
              // this.isOpenDropdownMenu = false
            },
          },
        ]
      },
    },
    methods: {
      // changeFilter(val) {
      //   this.$emit('changeFilter', val)
      // },
      changeFilter: _debounce(function () {
        // const value = this.$refs.filter.getCheckedKeys()
        //   .filter((id) => id);


        // setWindowHistory({
        //   query: {
        //     ...this.$route.query,
        //     [this.name]: value.join(',') || undefined
        //   }
        // });
        this.$emit('input', this.data);
        if(this.type === 'prompt') {
          this.$emit('changeFilter', this.data);
        }
      }, 600),
      onOpenMenu() {
        if(this.type === 'click') {
          this.isOpenMenu = !this.isOpenMenu
        }else {
          this.isOpenDropdownMenu = !this.isOpenDropdownMenu
        }
      },
    }
  }
</script>
<template>
  <div :class="[$style.baseFilter,{ 'isOpenMenu': isOpenMenu }]">
    <div class="baseFilter__top">
      <BaseButton
        class="isText d-flex ml-auto mb-4"
        @click="isOpenMenu = false"
      >
        <i style="font-size: 18px;" class="icomoon icon-cross"></i>
      </BaseButton>
      <h4>{{title}}</h4>
      <el-divider></el-divider>
    </div>
    <div
      class="baseFilter__title"
      :class="titleClass"
      @click="onOpenMenu"
    >
      <div>{{ title }}</div>
      <i
        v-if="!isOpenMenu"
        class="fal fa-chevron-right baseFilter__headerIcon d-md-none"
      >
      </i>
      <i
        v-if="!isOpenDropdownMenu"
        class="fal fa-plus baseFilter__headerIcon d-md-inline d-none"
      >
      </i>
      <i
        v-else
        class="fal fa-minus baseFilter__headerIcon d-md-inline d-none"
      >
      </i>
      
    </div>
    <div
      class="baseFilter__checkBoxGroup"
      :class="{ 'isActive': isOpenDropdownMenu }"
    >
      <el-checkbox-group
        v-if="list.length"
        v-model="data"
        class="isStyleFilter"
        @change="changeFilter"
      >
        <el-checkbox
          v-for="(item, index) in list"
          :key="index"
          :label="item.alias"
        >
          {{ item.title || item.text }}
        </el-checkbox>
      </el-checkbox-group>
      <div v-else class="color-gray-6 pl-3 mb-4">
        沒有符合搜尋條件
      </div>
    </div>
    <div class="baseFilter__selectBoxGroup">
      <el-select
        v-model="data"
        class="isStyleMenu"
        :placeholder="`篩選${title}`"
        multiple
        @change="changeFilter"
      >
        <el-option
          v-for="(item, index) in list"
          :key="index"
          :label="item.title"
          :value="item.alias">
        </el-option>
      </el-select>
    </div>
    <BaseButtonBar
      :button-list="buttonBarList"
      is-show
      class="baseFilter__buttonBarList"
    />
  </div>
</template>
<style lang="scss" module>
  .baseFilter {
    border-bottom: 1px solid $color-gray-3;

    @include max-lg {
      border-bottom: 0;
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }
    @include max-md {
      &:not(:last-child) {
        margin-bottom: 0;
      }
    }
    :global {
      .baseFilter {
        &__top {
          display: none;
        }
        &__title {
          // display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1.8rem 0;
          font-size: 1.5rem;
          font-weight: 500;
          cursor: pointer;
          @include max-md {
            padding: 1rem 0;
            font-size: 1.125rem;
          }
        }

        &__menuList {
          @include list-unstyled;

          margin-bottom: -1rem;

          &__item {
            margin-bottom: 1rem;
          }

          &__link {
            display: block;
            color: $color-gray-7;

            &.router-link-active {
              color: $color-primary
            }

            &.isActive, &:hover, &:active {
              color: $color-primary;
              text-decoration: none;
            }
          }
        }
        &__checkBoxGroup {
          display: block;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.5s;
          @include max-md {
            max-height: inherit;
            overflow: visible;
          }
          @include max-lg {
            display: none;
          }
          &.isActive {
            max-height: 2000px;
            @include max-md {
              max-height: inherit;
            }
          }
          // @include max-md {
          //   display: block;
          // }
        }
        &__selectBoxGroup {
          display: none;
          overflow: hidden;
          @include max-lg {
            display: block;
          }
          @include max-md {
            display: none;
          }
        }
        &__buttonBarList {
          display: none;
        }
      }
    }
    &:global {
      &.isOpenMenu {
        @include max-md {
          @include var-height(100);
          position: fixed;
          left: 0;
          top: 0;
          z-index: 2000;
          padding: 17px 19px 12rem;
          overflow-y: auto;
          width: 100%;
          background: #fff;
          
          .baseFilter {
            &__top {
              display: block;
            }
            &__title {
              display: none !important;
            }
            &__checkBoxGroup {
              display: block;
            }
            &__buttonBarList {
              display: block;
            }
          }
        }

      }
      &.isSingle {
        border-bottom: 0;
        .baseFilter{
          &__headerIcon {
            opacity: 0;
            @include max-md {
              opacity: 1;
            }
          }
          &__title {
            cursor: auto;
          }
          &__checkBoxGroup {
            max-height: 2000px;
          }
        }
      }
    }
  }
</style>
